// extracted by css-extract-rspack-plugin
export default {"photo":"_858c65f3","fadeIn":"_387f81be","forceOpacity":"_f68a933b"};